<template>
  <div v-if="selectedMenu == 1" class="uv-card">
    <div class="uv-card-body">
      <ModuleHeader>Conceptos de membresia</ModuleHeader>
      <uv-data-table
        :config="config"
        :data="comp_conceptos"
        :pageRows="15"
        @buttonClick="dtButtonClick"
      ></uv-data-table>
    </div>
    <modal ref="modalForm" v-model="showModal" :showFooter="false">
      <ConceptoForm
        :edit="editMode"
        :key="formIndex"
        @toggle="toggleModal"
        :dataEdit="editData"
        @successData="successData"
      />
    </modal>
  </div>
</template>



<script>
import uvDataTable from "../../MainComponents/DataTable.vue";
import modal from "../../MainComponents/modal.vue";
import ConceptoForm from "./ConceptoForm.vue";
import PeriodosCobro from "../../../clases/Membresias/PeriodosCobro.js";
import { mapActions } from "vuex";

export default {
  name: "ConceptosCRUD",
  components: {
    uvDataTable,
    ConceptoForm,
    modal,
  },
  data() {
    return {
      formIndex: 0,
      editMode: false,
      editData: {},
      indexComponent: 1,
      access: [],
      gruposCliente: [],
      showModal: false,
      config: {
        selectableRow: true,
        orderByCol: { Field: "", Type: "Asc" },
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "addConcepto",
          },
          {
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editarConcepto",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteConcepto",
            require: true,
          },
        ],
        fields: [
          {
            text: "Nombre",
            value: "dscr",
          },
          {
            text: "Código",
            value: "code",
          },
          {
            text: "Categoría",
            value: "CategoriName",
            canBeFiltered: true,
          },            

        ],
      },
      fullAccess: false,
      idSelected: "",
      claims: {},
      data_periodos: [],
      data_clientes: [],
      conceptos:[],
      Categories:[],
      selectedMenu: 1,
    };
  },
  computed: {
    comp_conceptos(){
      let conceptos = this.conceptos
      conceptos.forEach((conc)=>{
        conc.CategoriName = this.$pgsHelper.getById(this.Categories,'id',conc.ctgr).Nombre
      })
      return conceptos;
    }
  },
  methods: {
    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    successData(data, doAction) {
      if (doAction == "CREATE") {
        this.createConcepto(data);
      } else if (doAction == "EDIT") {
        this.editarConcepto(data);
      }
    },
    async getUserGroups() {
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder("PDV/GruposCliente")
      let arrayGrupos = Object.entries(data.val());
      let grupos = [];
      arrayGrupos.forEach(function (element) {
        grupos.push({ value: element[0], text: element[1]["Nombre"] });
      });
      this.gruposCliente = grupos;
    },
    dtButtonClick(buttonId, idSelected) {
      this.formIndex++;
      if (buttonId == "addConcepto") {
        this.idSelected = "";
        this.editMode = false;
        this.editData = {};
        this.$refs.modalForm.setTitle("Agregar concepto");
        this.toggleModal(true);
      }
      if (buttonId == "editarConcepto") {
        this.idSelected = idSelected[0];
        const cashier = this.$pgsHelper.getById(
          this.conceptos,
          "id",
          idSelected[0]
        );
        this.editMode = true;
        this.editData = cashier;
        this.$refs.modalForm.setTitle("Editar concepto");
        this.toggleModal(true);
      }
      if (buttonId == "deleteConcepto") {
        this.deleteConcepto(idSelected[0]);
      }
    },
    createConcepto(data) {
      this.$alert.alertConfirm(
        {
          action:"guardar",
          obj:"el concepto de membresia",
          route:'MBS-Conceptos-createConcepto',
          data:data,
          onSuccess:()=>{
            this.getConceptos()
            this.toggleModal(false);
          }
        })
    },
    editarConcepto(data) {
      this.$alert.alertConfirm(
        {
          action:"editar",
          obj:"el concepto de membresia",
          route:'MBS-Conceptos-updateConcepto',
          data:data,
          onSuccess:()=>{
            this.getConceptos()
            this.toggleModal(false);
          }
      })
    },
    deleteConcepto(id) {
      let datos = { Id: id };
      this.$alert.alertConfirm(
        {
          action:"eliminar",
          obj:"el periodo de cobro",
          route:'MBS-Conceptos-deleteConcepto',
          data:datos,
          onSuccess:()=>{
             this.getConceptos()
            this.toggleModal(false);
          }
      })
    },
    toggleModal(open) {
      this.showModal = open;
    },
    async getConceptos(){
      const database    = this.$store.getters.getFirebaseApp.database;
      const ref         = database.ref("MBS/Conceptos");
      const snapshot    = await database.get(ref);
      if(!snapshot.exists()){
        return false;
      }
      this.conceptos      = this.$pgsHelper.ArrayObjectToArray(snapshot.val());
      
    },
    async getCategories() {
      this.Categories = await this.fetchCategories();
    },
  },
  beforeMount: function () {},
  mounted: async function () {
    await this.getCategories();
    await this.getConceptos()
  },
};
</script>